export default {
    name: 'carousel',
    serverName: '/api/v1/disease/cultures/',
    apiCulturesUrl: '/api/v1/disease/cultures/?display=culture&page_size=1000',
    apiSymptomsUrl: '/api/v1/disease/cultures/?display=symptoms&page_size=1000',
    apiDiseasesUrl: '/api/v1/disease/cultures/?display=disease&page_size=1000'
};
